import { render, staticRenderFns } from "./SPIFCashTables.vue?vue&type=template&id=1363c799"
import script from "./SPIFCashTables.vue?vue&type=script&lang=js"
export * from "./SPIFCashTables.vue?vue&type=script&lang=js"
import style0 from "./SPIFCashTables.vue?vue&type=style&index=0&id=1363c799&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports